import { DeviceConfig, mainDeviceConfig } from './device-config';

export class IotahDevice implements DeviceConfig {
	config: mainDeviceConfig = {
		sct_device_type: 0,
		isIotah: true,
		isCharglink: false,
		isBattlink: false,
		isBrm: false,
		is_eMeter: false,
		is_iotemeter: false,
		hasTypes: true,
		couldHaveStudy: true,
		typeString: 'Truklink',
		translationPath: '',
		imageFolder: '/forklift',
		logoStyleClass: '',
		mapColor: 'orange',
		setLastMaintenanceDate: true,
		hasMaintenanceSchedule: true,
		hasBatterySettings: true,
		CO2data: true,
		permissionMapperKey: '',
		mapperOverrideFile: "iotemeterMapper",
		supportIncorrectEvent: true,
		hasLoadScheduling: false,
		hasRequestManageDevice: true,
		hasManageDevice: true,
		deviceSettingTabs: ['info','deviceSettings','batterySettings','cal','networkingSettings','networking','billedKWHrsSettings','maintenanceSchedule','official-reporting','connectivityFrequency'],
		hasLoadPowerStatusStop: false,
		hasImCalibration: false,
		fields: {
			kwhr: 'inuse_kwhr',
			hasMaxChargerKw: false,
			hasTemperatureSensor: true,
			hasShiftSchedule: true,
			hasWaterLevel: true,
			hasHallEffect: true,
			trickleVoltage: true,
			cvTargetVoltage: true,
			fiTargetVoltage: true,
			eqVoltage: true,
			trickleCurrentRate: true,
			ccRate: true,
			cvEndCurrentRate: true,
			cvCurrentStep: true,
			fiCurrentRate: true,
			eqCurrentRate: true,
			batteryCapacity: true,
			batteryType: true,
			numberOfCells: true,
			batteryTemperatureCompensationInMv: true,
			fiDt: true,
			fiDv: true,
			liftCurrentThresholdPercentage: true,
			liftCurrentThresholdValue: true,
			liftCurrentThresholdDeltaPercentage: true,
			liftCurrentThresholdDeltaValue: true,
			deadManTime: true,
			returnFactor: true,
			batteryEfficiency: true,
			chargerEfficiency: true,
			deadManCurrentLimit: true,
			chargerType: false,
			chargerVoltage: false,
		},
		requiredFields: {
			truckType: true,
			truckManufacturer: true,
			truckManufacturingYear: true,
			truckManufacturingMonth: false,
			currentLiftLowerThreshold: true,
			currentLiftUpperThreshold: true,
		},
		incorrectEvent: {
			type: 'charge',
		},
		quarterlyUsage: {
			hasTypeFilter: true,
			hasYearFilter: true,
			performanceChartType: 'i',
			hasChartLegend: false,
			chartGridColumns: 12,
			hasTotalTravelTimeChart: true,
			hasTotalLiftTimeChart: true,
			period: 'months',
			perfAnalyticsKey: 'perf_analytic.monthly_data',
		},
		reporting: {
			device: 'iotah',
		},
		dailyDetails: {
			hasField: {
				billed_kwh: true,
				accurate_inuse_seconds: true,
				lift_time: true,
				travel_time: true,
				ah_h: false,
				ebu: false,
				eq: false,
				missed_fi: false,
			},
			hasTypes: {
				endVoltage: true,
				chargerEndVoltage: false,
				idleTimes: true,
			},
			hasOrPowerStudy: {
				min_soc: false,
			},
			useBilledKwh: false
		},
		events: {
			hasFields: {
				billed_kwh: true,
				lift_time: true,
				travel_time: true,
				accurate_inuse_seconds: true,
				flag_finish: false,
				flag_eq: false,
				flag_finish_start: false,
				flag_eq_start: false,
				finish_reason: false,
				eq_reason: false,
				fromNode: false,
				hasEnergyColumns: true,
			},
			hasOrPowerStudy: {
				start_soc: false,
				end_soc: false,
			}
		},
		usage: {
			summaryField: 'usage_summary',
			accurateSecondsField: 'accurate_inuse_seconds'
		},
		performance: {
			hasEndVoltageReport: true,
			hasInuseEndVoltageReport: true,
			hasChargeEndVoltageReport: false,
			hasIdleEventsReport: true,
			hasImUsageDataReport: false,
			hasImPowerPeakReport: false,
			hasImTotalEnergyUsageReport: false,
			hasRegenReport: true,
			hasUsageAsReport: true,
			hasUsageTimeWidget: true,
			usageSummaryKey: 'amp_usage_summary',
			kwuUsageSummaryKey: 'kw_usage_summary',
			hasDataWidget: true,
			hasRelativeUsageWidget: true,
			hasBatteriesCustomizedCharts: false,
			chargeOpportunity: false,
			hasBatteryPerformance: false,
			hasPowerUsageCharts: true,
			hasUsageReport: true,
			hasTruckHoursReport: true,
			has_soc: false,
			vpc_charts: false,
			water_level_chart: false,
			hasBatteryLifeMetics: false,
			batteryPerformanceScore: false,
			hasBatteryReport: false,
			hasTruckReport: true,
		},
		customer: {
			mix_quarterly_usage_kwh: false
		},
		quickView: {
			hasInsight: true,
			hasLiveEvent: true,
			hasLiveRT: true,
			hasWarnings: true,
			hasCalc: true,
			hasMeterGauge: false,
			hasLoadControl: false,
		},
		rts: {
			has_soc: false,
		},
	};

	getImagePath(imageType: 'not_connected' | 'connected' | 'inuse' | 'idle', options: {is_study_device: boolean} = {is_study_device : false}): string {
		let imageLink = '/images' + this.config.imageFolder;

		switch (imageType) {
			case 'not_connected':
				imageLink += `_gray.png`;
				if (options.is_study_device)
					imageLink = 'images/studies/not_connected.png';
				break;
			case 'connected':
				imageLink += `_connected.png`;
				if (options.is_study_device)
					imageLink = 'images/studies/connected.png';
				break;
			case 'inuse':
				imageLink = '/images/forklift_inuse.gif';
				break;
			case 'idle':
				imageLink = '/images/forklift_idle.png';
				break;
		}

		return imageLink;
	}

	getEventImage(eventType: string, is_study_device: boolean): string {
		let eventTypeText : 'not_connected' | 'connected' | 'inuse' | 'idle' = eventType == 'inuse'? 'inuse' : 'idle';

		if (is_study_device)
			eventTypeText = 'connected';

		return this.getImagePath( eventTypeText, {is_study_device});
	}

	getTypesString(options: {getPowerStudyDevices: boolean, is_study_device: boolean} = {getPowerStudyDevices: false, is_study_device: false}) {
		if (options.getPowerStudyDevices && this.config.couldHaveStudy && options.is_study_device)
			return 'Study';

		return 'Truklink';
	}
}
